import { Button, Modal, Row } from "react-bootstrap";
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { deleteGuestInChair, editGuestInChair } from "../../../store/slices/group/thunks";
import { MySelect } from "../../ui/controls/MySelect";

export const EditGuest = ({ code, isOpen, setIsOpen, chair }) => {
  const { guestList, weedingPassList } = useSelector((state) => state.group);
  const dispatch = useDispatch();

  const delete2 = () => {
    const success = () => {
      setIsOpen(false)
    }
    dispatch(deleteGuestInChair(chair.idChair, code, success));
  }

  return (
    <>
      <Modal
        size="xl"
        show={isOpen}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title >
            Editar Invitado En Mesa
          </Modal.Title>
          <Button
            onClick={() => setIsOpen(false)}
            className="btn-close"
            variant=""
          >
            x
          </Button>
        </Modal.Header>

        <Formik
          initialValues={{
            guest: { "value": chair.idGuest, "label": chair.guest },
            externalGuest: { "value": chair.idExternalGuest, "label": chair.externalGuest },
          }}
          onSubmit={(({ guest, externalGuest }, { resetForm, setErrors }) => {

            if (!guest && !externalGuest) {
              return setErrors({ "guest": "Requerido" })
            }

            const success = () => {
              resetForm();
              setIsOpen(false)
            }

            dispatch(editGuestInChair(guest ? guest.value : null, externalGuest ? externalGuest.value : null,
              chair.idChair, code, success));
          })}
          validationSchema={
            Yup.object({
            })
          }
        >

          {
            ({ setFieldValue }) => (
              <Form>
                <Modal.Body>
                  <Row>
                  <div className="col-lg-12 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Invitado:*' name="guest" options={guestList} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("guest", e);
                            setFieldValue("externalGuest", null);
                          }} />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className=" row mb-4">
                        <MySelect label='Invitado Externo:*' name="externalGuest" options={weedingPassList} mode='horizontal'
                          singleSelect="true"
                          onChange={e => {
                            setFieldValue("externalGuest", e);
                            setFieldValue("guest", null);
                          }} />
                      </div>
                    </div>
                  </Row>
                  <div style={{ fontSize: 13 }}>* Dato obligatorio</div>
                </Modal.Body>

                <Modal.Footer>
                  <Row style={{ width: "100%" }}>
                    <div className="col-lg-4 col-md-4 col-4">
                      <Button variant="danger" type="button" onClick={delete2}>
                        Eliminar
                      </Button>
                    </div>
                    <div className="col-lg-4 col-md-3 col-3" style={{ textAlign: "center" }}>
                    </div>
                    <div className="col-lg-4 col-md-5 col-5" style={{ textAlign: "right" }}>
                      <Button variant="primary" type="submit">
                        Guardar
                      </Button>
                    </div>
                  </Row>
                </Modal.Footer>
              </Form>
            )
          }
        </Formik>
      </Modal>
    </>
  )
}
